
export function getAreaName(val, data) {
	console.log(val)
	console.log(data)
    let [proviceId, cityId, AreaId] = val;
	console.log(proviceId)
	console.log(cityId)
    let proviceName, cityName, areaName
    
    for(let i=0; i<data.length; i++) {
        let v = data[i]
        if (v.value === proviceId) {
            proviceName = v.label;
            for (let j = 0; j < v.cities.length; j++){
                let v2 = v.cities[j];
                if (v2.value === cityId) {
                    cityName = v2.label
                    for (let k = 0; k < v2.cities.length; k++) {
                        let v3 = v2.cities[k];
                        if (v3.value === AreaId) {
                            areaName = v3.label
                            break
                        }
                    } 
                    break
                }
            }
            break
        }
    }
    return { proviceName, cityName, areaName};
}
